import gsap from 'gsap'
import store from '@/store'
import interpolate from 'color-interpolate'
import { playUnlock } from '@/lib/sound.js'

let triggered = false

function updateButtonStyle(button, drag_x_delta, drag_x_colour) {
  button.style.transform = `translate(${drag_x_delta}px, 0px)`
  button.style.color = drag_x_colour
  button.style.borderColor = drag_x_colour
}

function removeButtonStyle(button) {
  button.style.transform = null
  button.style.color = null
  button.style.borderColor = null
}

function slingshot(mouseDownEvent) {
  const colormap = interpolate(['#cdf4dd', '#468B18'])
  const drag_start_x =
    mouseDownEvent.type == 'touchstart'
      ? mouseDownEvent.changedTouches[0].clientX
      : mouseDownEvent.clientX

  const original_button_position = document
    .getElementById('button-6')
    .getBoundingClientRect()

  const move_listener = function (e) {
    //const lambda = 0.0025
    const lambda = 0.007
    const clientX =
      e.type == 'touchmove' ? e.changedTouches[0].clientX : e.clientX
    const offset = Math.max(Math.min(clientX - drag_start_x, 1 / lambda), 0)
    const drag_x_delta = Math.exp(-lambda * offset) * offset
    const drag_x_pct = offset / (1 / lambda)
    if (drag_x_pct > 0.75) {
      triggered = true
    } else {
      triggered = false
    }
    const drag_x_colour = colormap(drag_x_pct * (1 / 0.75))
    store.commit('SET_UNLOCK_PROGRESS', (drag_x_pct * 100) / 0.75)
    updateButtonStyle(
      document.getElementById('button-6'),
      drag_x_delta,
      drag_x_colour
    )
  }
  window.addEventListener('mousemove', move_listener)
  window.addEventListener('touchmove', move_listener)

  const mouseup_listener = function () {
    console.log('mouseup')
    window.removeEventListener('mousemove', move_listener)
    window.removeEventListener('mouseup', mouseup_listener)
    window.removeEventListener('touchmove', move_listener)
    window.removeEventListener('touchend', mouseup_listener)

    store.commit('SET_UNLOCK_PROGRESS', 0)

    if (!triggered) {
      gsap.to(document.getElementById('button-6'), {
        x: 0,
        color: '#cdf4dd',
        borderColor: '#cdf4dd',
        duration: 0.2,
        onComplete: () => {
          console.log('completed')
          store.commit('SET_CODE_SCREEN', 'CodeScreenBase')
          resetAllButtons()
        },
      })
      return
    }

    let unlocking = false
    if (!store.getters.isActionUnlocked('slingshot')) {
      unlocking = true
      playUnlock()
    } else {
      store.commit('SET_MOVE_NAME_ANIMATE', store.getters.actions['slingshot'])
    }
    store.commit('SET_BLOCK_CLICKS', [1, 2, 3, 4, 5, 6, 7, 8, 9])

    setTimeout(
      () => {
        removeButtonStyle(document.getElementById('button-6'))
        wallBounceAnim(
          document.getElementById('button-4'),
          document.getElementById('button-5'),
          document.getElementById('button-6'),
          original_button_position,
          () => {
            let new_vals = [...store.getters.button_vals]
            const old_three = new_vals[3]
            new_vals[3] = new_vals[5]
            new_vals[5] = new_vals[4]
            new_vals[4] = old_three
            triggered = false
            store.commit('SET_BUTTON_VALS', new_vals)
            if (unlocking) {
              store.dispatch('unlock_action', 'slingshot')
              setTimeout(() => {
                store.commit('SET_SHOW_UNLOCK_DIALOG', true)
              }, 500)
            } else {
              store.commit('SET_BLOCK_CLICKS', [])
            }
            resetAllButtons()
          }
        )
      },
      unlocking ? 1000 : 0
    )
  }
  window.addEventListener('mouseup', mouseup_listener)
  window.addEventListener('touchend', mouseup_listener)
}

function wallBounceAnim(
  button_1,
  button_2,
  button_3,
  button_3_orig_pos,
  onComplete
) {
  // Buttons are arranged horizontally: button_1 button_2 button_3
  const button_1_pos = button_1.getBoundingClientRect()
  const button_2_pos = button_2.getBoundingClientRect()

  const max_left_offset = Math.max(
    -(button_3_orig_pos.x - button_1_pos.x) - 100,
    -button_3_orig_pos.x
  )

  const tl = gsap.timeline()
  tl.to(button_3, {
    x: max_left_offset,
    duration: 0.3,
    ease: 'power3.out',
  })

  tl.to(button_3, {
    x: -(button_3_orig_pos.x - button_1_pos.x + button_1_pos.width),
    duration: 0.3,
    ease: 'power3.in',
  })

  tl.to(
    button_2,
    {
      x: button_3_orig_pos.x - button_2_pos.x,
      duration: 0.1,
    },
    'final_shift'
  )

  tl.to(
    button_1,
    {
      x: button_2_pos.x - button_1_pos.x,
      duration: 0.1,
    },
    'final_shift'
  )

  tl.to(
    button_3,
    {
      x: -(button_3_orig_pos.x - button_1_pos.x),
      duration: 0.1,
      onComplete: () => {
        gsap.set(button_1, { x: 0 })
        gsap.set(button_2, { x: 0 })
        gsap.set(button_3, { x: 0 })
        onComplete()
      },
    },
    'final_shift'
  )
}

function resetAllButtons() {
  const button_ids = [
    'button-1',
    'button-2',
    'button-3',
    'button-4',
    'button-5',
    'button-6',
    'button-7',
    'button-8',
    'button-9',
  ]
  button_ids.forEach((b) => resetButtonStyle(b))
}

function resetButtonStyle(button_id) {
  const button = document.getElementById(button_id)
  gsap.set(button, { clearProps: 'all' })
}

export default slingshot
